import { ISusuario, Usuario } from "../usuario/Usuario";
import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";
import { ISprocesso, Processo } from "./Processo";

export interface ProcessoAtribuir {
    id: string;
    usuario: Usuario;
    processoId: string;
    observacao: string | null;
}

export const ISprocessoAtribuir: ProcessoAtribuir = {
    id: "",
    usuario: ISusuario,
    processoId: "",
    observacao: null,

}